var CurrentUser = require("lib/account/CurrentUser");

var SkillsetStandardPreference = require("components/users/teachers/preferences/SkillsetStandardPreference");
var ClassShelfPreference = require("components/users/teachers/preferences/ClassShelfPreference");
var SoundPreference = require("components/users/teachers/preferences/SoundPreference");
var QuizScoringPreference = require("components/users/teachers/preferences/QuizScoringPreference");
var QuestionCustomizer = require("components/users/teachers/QuestionCustomizer");
var ClozeCustomizer = require("components/users/teachers/ClozeCustomizer");
var SpeechControlsPreference = require("components/users/teachers/preferences/SpeechControlsPreference");

var WritingDeletionPreference = require("components/users/teachers/preferences/WritingDeletionPreference");
var LogReadingPreferences = require("components/users/teachers/preferences/LogReadingPreferences");
var OwlShopPreference = require("components/users/teachers/preferences/OwlShopPreference");
var SchoolYearMonthsPreference = require("components/users/teachers/preferences/SchoolYearMonthsPreference");
var ZPDPreferences = require("components/users/teachers/preferences/ZPDPreferences");
var InformationPreferences = require("components/users/teachers/preferences/InformationPreferences");
var PaymentPreferences = require("components/users/teachers/preferences/PaymentPreferences");
var PlanPreferences = require("components/users/teachers/preferences/PlanPreferences");
var ClozeCustomizer = require("components/users/teachers/ClozeCustomizer");
var ReferralPreference = require("components/users/teachers/preferences/ReferralPreference");
var QuestionBuilderPreferences = require("components/users/teachers/preferences/QuestionBuilderPreferences");
var UpgradeCodeTablePreference = require("components/users/teachers/preferences/UpgradeCodeTablePreference")
var LinkAccountsPreferences = require("components/users/teachers/preferences/LinkAccountsPreferences")
var MergeAccountsPreferences = require("components/users/teachers/preferences/MergeAccountsPreferences")
var QuizLimitPreference = require("components/users/teachers/preferences/QuizLimitPreference")

var RosteringMethodPreference = require("components/org/preferences/RosteringMethodPreference");
var ActivationCodesPreferences = require("components/org/preferences/ActivationCodesPreferences");
var GeneralOrgPreferences = require("components/org/preferences/GeneralOrgPreferences");
var SchoolContestPreference = require("components/org/preferences/SchoolContestPreference");


require("users/teachers/preferences.scss");

class Preferences extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		this.state = {
			loading: false
		}
	}

	render() {
		if (this.props.type == Preferences.QUIZ_SCORING) {
			var preferenceContent = (
				<QuizScoringPreference />
			);
		} else if (this.props.type == Preferences.DISPLAY_CLASS_SHELF) {
			var preferenceContent = (
				<ClassShelfPreference />
			);

		} else if (this.props.type == Preferences.SKILLSET_CUSTOMIZER) {
			var preferenceContent = (
				<SkillsetStandardPreference />
			);

		} else if (this.props.type == Preferences.QUESTION_CUSTOMIZER) {
			var preferenceContent = (
				<QuestionCustomizer />
			);

		} else if (this.props.type == Preferences.CLOZE_CUSTOMIZER) {
			var preferenceContent = (
				<ClozeCustomizer />
			);

		} else if (this.props.type == Preferences.SPEECH_CONTROLS) {
			var preferenceContent = (
				<SpeechControlsPreference />
			);

		} else if (this.props.type == Preferences.SCHOOL_YEAR) {
			var preferenceContent = (
				<SchoolYearMonthsPreference />
			)

		} else if (this.props.type == Preferences.SOUND_OPTION) {
			var preferenceContent = (
				<SoundPreference />
			)

		} else if (this.props.type == Preferences.ALLOW_STUDENT_WRITING_DELETION) {
			var preferenceContent = (<WritingDeletionPreference />)
		} else if (this.props.type == Preferences.BACK_LOG_DATE_PERIOD) {
			var preferenceContent = (<LogReadingPreferences />)
		} else if (this.props.type == Preferences.OWL_SHOP) {
			var preferenceContent = (<OwlShopPreference />)
		} else if (this.props.type == Preferences.ZPD) {
			var preferenceContent = (<ZPDPreferences />)
		} else if (this.props.type == Preferences.INFORMATION) {
			var preferenceContent = (<InformationPreferences />)	
		} else if (this.props.type == Preferences.PAYMENT) {
			var preferenceContent = (<PaymentPreferences billingHistory={ this.props.billingHistory } />)
		} else if (this.props.type == Preferences.PLAN) {
			var preferenceContent = (<PlanPreferences />)
		} else if (this.props.type == Preferences.READING_LEVEL) {
			var preferenceContent = (<ClozeCustomizer />)
		} else if (this.props.type == Preferences.REFERRAL) {
			var preferenceContent = (<ReferralPreference />)
		} else if (this.props.type == Preferences.ALLOW_STUDENT_QUESTION_BUILDER) {
			var preferenceContent = (<QuestionBuilderPreferences />)
		} else if (this.props.type == Preferences.CODE_TABLE) {
			var preferenceContent = (<UpgradeCodeTablePreference />)
		} else if (this.props.type == Preferences.LINK_ACCOUNTS) {
			var preferenceContent = (<LinkAccountsPreferences />)
		} else if (this.props.type == Preferences.MERGE_USERS) {
			var preferenceContent = (<MergeAccountsPreferences />)
		} else if (this.props.type == Preferences.QUIZ_LIMIT){
			var preferenceContent = (<QuizLimitPreference />)
		} else if (this.props.type == Preferences.ROSTERING_METHOD) {
			var preferenceContent = (<RosteringMethodPreference />)
		} else if (this.props.type == Preferences.ACTIVATION_CODES) {
			var preferenceContent = (<ActivationCodesPreferences />)
		} else if (this.props.type == Preferences.GENERAL_ORG_SETTINGS) {
			var preferenceContent = (<GeneralOrgPreferences />)
		} else if (this.props.type == Preferences.SCHOOL_CONTEST) {
			var preferenceContent = (<SchoolContestPreference />)
		}

		return (
			<div className="preferenceContainer">
				{ preferenceContent }
			</div>
		);
	}
};

Preferences.ALLOW_STUDENT_WRITING_DELETION = "AllowStudentWritingDeletion";
Preferences.BACK_LOG_DATE_PERIOD = "BackLogDatePeriod";
Preferences.QUIZ_SCORING = "QuizScoring";
Preferences.DISPLAY_CLASS_SHELF = "DisplayClassNewsShelf";
Preferences.SCHOOL_YEAR = "SchoolYear";
Preferences.SOUND_OPTION = "Sound";
Preferences.SKILLSET_CUSTOMIZER = "SkillsetsStandards";
Preferences.QUESTION_CUSTOMIZER = "QuestionCustomizer";
Preferences.SPEECH_CONTROLS = "SpeechControls";
Preferences.CLOZE_CUSTOMIZER = "ClozeCustomizer";
Preferences.LOG_BACK_DATING_PERIOD = "LogBackDatingPeriod";
Preferences.OWL_SHOP = "OwlShop";
Preferences.ZPD = "zpd";
Preferences.INFORMATION = "Information";
Preferences.PAYMENT = "Payment";
Preferences.PLAN = "Plan";
Preferences.READING_LEVEL = "Reading Level";
Preferences.REFERRAL = "Referral";
Preferences.ALLOW_STUDENT_QUESTION_BUILDER = "displayQuestionBuilder"
Preferences.LINK_ACCOUNTS = "Link Accounts"
Preferences.MERGE_USERS = "Merge Users"

// ORG SETUP CHECKLIST
Preferences.ROSTERING_METHOD = "Rostering Method"
Preferences.ACTIVATION_CODES = "Activation Codes"
Preferences.GENERAL_ORG_SETTINGS = "General Settings"
Preferences.CODE_TABLE = "Code Table"
Preferences.SCHOOL_CONTEST = "School Contest"

Preferences.propTypes = StrictPropTypes({
	type: PropTypes.string.isRequired,
	classShelfDisplaySetting: PropTypes.bool,
	billingHistory: PropTypes.array,
	onChange: PropTypes.func
});

module.exports = Preferences;



// WEBPACK FOOTER //
// ./modules/components/users/teachers/Preferences.js